import { useQuery } from '@apollo/client';
import { useCurrentAccount } from '@application/api';
import { graphql } from '@gql/gql';
import { DogBreederApplicationStatus } from '@gql/graphql';
import type {
  ApplicationGetApplicationExistsForBreederIdQuery,
  ApplicationGetApplicationExistsForBreederIdQueryVariables,
} from '@gql/graphql';

export const APPLICATION_GET_APPLICATION_EXISTS_FOR_BREEDER_ID = graphql(`
  query ApplicationGetApplicationExistsForBreederId(
    $where: DogBreederApplicationWhereInput
    $take: Int
  ) {
    accountMe {
      id
      applications(where: $where, take: $take) {
        id
      }
    }
  }
`);

export const useGetApplicationExistsForBreederId = (breederId?: number) => {
  const { currentAccountLoggedIn, currentAccountLoading } = useCurrentAccount();

  const { data, loading } = useQuery<
    ApplicationGetApplicationExistsForBreederIdQuery,
    ApplicationGetApplicationExistsForBreederIdQueryVariables
  >(APPLICATION_GET_APPLICATION_EXISTS_FOR_BREEDER_ID, {
    variables: {
      take: 1,
      where: {
        archived: { equals: false },
        dogBreederId: { equals: breederId },
        status: {
          in: [
            DogBreederApplicationStatus.AWAITING_PAYMENT,
            DogBreederApplicationStatus.CONTACT_AVAILABLE,
            DogBreederApplicationStatus.DONE,
            DogBreederApplicationStatus.WAITING_LIST,
          ],
        },
      },
    },
    ssr: false,
    fetchPolicy: 'no-cache',
    skip: !currentAccountLoggedIn || !breederId,
  });

  return {
    application: data?.accountMe?.applications[0],
    applicationLoading: loading || currentAccountLoading,
  };
};
